// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2PNif","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3i92k","obliqueLine":"membershipbadge_obliqueLine__WxbNJ"};